import { GridColDef } from '@mui/x-data-grid';

import LinkContent from '~/components/Cruises/pages/Home/components/Sailings/LinkContent';

import { DepartureBase } from '~/services/cruises/DepartureService';

export interface DepartureSearchState {
  name: string;
  shipName: string;
  departureDateStart: string;
  departureDateEnd: string;
  sailingDurationMin: string;
  sailingDurationMax: string;
  status: '' | 'ACTIVE' | 'INACTIVE';
  offerId: string;
  sailingExternalId: string;
  shipExternalId: string;
}

export const DEPARTURE_INITIAL_SEARCH: DepartureSearchState = {
  name: '',
  shipName: '',
  departureDateStart: '',
  departureDateEnd: '',
  sailingDurationMin: '',
  sailingDurationMax: '',
  status: '',
  offerId: '',
  sailingExternalId: '',
  shipExternalId: '',
};

export interface DepartureCommittedSearch extends DepartureSearchState {
  vendorId: string;
  departurePortExternalIds: Array<number>;
}

export const departureColumns: Array<GridColDef<DepartureBase>> = [
  {
    field: 'name',
    headerName: 'Name',
    flex: 2,
    sortable: false,
    disableColumnMenu: true,
    display: 'flex',
    renderCell: (params) => LinkContent({ title: params.row.name, url: `/cruises/sailings/${params.row.id}` }),
  },
  {
    field: 'externalId',
    headerName: 'External ID',
    flex: 1,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: 'shipName',
    headerName: 'Ship',
    flex: 1.5,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: 'departureDate',
    headerName: 'Departure Date',
    flex: 1.5,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 1,
    sortable: false,
    disableColumnMenu: true,
  },
];
